import AdminLayout from "components/common/AdminLayout";

function withAdminLayout(WrapperComponent) {
  return (props) => (
    <AdminLayout>
      <WrapperComponent {...props} />
    </AdminLayout>
  );
}

export default withAdminLayout;
